import React, {useState} from "react";
import "./index.scss";
import Title from "features/components/title";
import {Icon} from "features/components/icon";
import Text from "features/components/text";

export const HelpItem = (props) => {
    const {title, text} = props;

    const [open, setOpen] = useState(false);

    return <div className="help-item">
        <div className="help-title" onClick={() => setOpen(!open)}>
            <Title size={24}>{title}</Title>
            <Icon>{open ? "chevron-up" : "chevron-down"}</Icon>
        </div>
        <div className={`help-content ${open ? "open" : ""}`}>
            <Text size={16}>{text}</Text>
        </div>
    </div>
}